import { useEffect } from "react"
import { useSubcategoriasGastosForReportLazyQuery } from "src/gql/schema"
import { FlexibleTableHeaderColumn } from "src/shared/components/data-display/FlexibleTable/flexible-table-items.interface"
import { HeaderProps } from "../../hooks/useHeaderProps"
import { useProfile } from "src/shared/hooks/useProfile"

interface SubCategoriaGastoHeader<T extends string> extends HeaderProps<T> {
    categoria_id?: string[]
}

const useSubCategoriaGastoHeader = <T extends string>({
    headerValue,
    valueToDisplay,
    categoria_id,
}: SubCategoriaGastoHeader<T>): FlexibleTableHeaderColumn => {
    const [getSubcategorias, subcategorias] = useSubcategoriasGastosForReportLazyQuery()
    const { hotel_id } = useProfile()
    useEffect(() => {
        getSubcategorias({
            variables: {
                hotel_id,
            }
        })
    }, [])

    const options = [
        ...(subcategorias.data?.categorias_gasto.filter(cat => categoria_id?.length ? categoria_id?.includes(cat.categoria_id) : true).flatMap(cat => cat.subcategorias_de_categoria).map((th) => ({
            value: th.subcategoria,
            valueToDisplay: th.subcategoria,
        })) || []),
    ]

    return {
        value: headerValue,
        valueToDisplay,
        filterMenu: options,
        isFilterUnique: false,
        filterSuggetions: true,
    }
}

export default useSubCategoriaGastoHeader
